module.exports = __webpack_public_path__ + "img/andysequence_thumb.2264648a.jpg";